/**
 * Break API Contract
 *
 * Mirrors: backend/src/routes/break.routes.ts
 * 1:1 parity with existing Express routes
 */
import { oc } from "@orpc/contract";
import { z } from "zod";
import { CreateBreakInputSchema, UpdateBreakInputSchema, BreakResponseSchema, } from "@hourly/api/break";
import { uuidSchema } from "@hourly/api/validation-common";
// ============================================
// Break Contracts
// ============================================
/**
 * POST /api/breaks
 * Create a new break
 */
export const createBreak = oc
    .route({
    method: "POST",
    path: "/breaks",
    summary: "Create a new break",
    tags: ["Breaks"],
    successStatus: 201,
})
    .input(CreateBreakInputSchema)
    .output(BreakResponseSchema);
/**
 * GET /api/breaks/:id
 * Get a break by ID
 */
export const getBreak = oc
    .route({
    method: "GET",
    path: "/breaks/{id}",
    summary: "Get break by ID",
    tags: ["Breaks"],
})
    .input(z.object({ id: uuidSchema }))
    .output(BreakResponseSchema);
/**
 * GET /api/breaks/job-role-families/:jobRoleFamilyId/breaks
 * List breaks by job role family
 */
export const getBreaksByJobRoleFamily = oc
    .route({
    method: "GET",
    path: "/breaks/job-role-families/{jobRoleFamilyId}/breaks",
    summary: "List breaks by job role family",
    tags: ["Breaks"],
})
    .input(z.object({ jobRoleFamilyId: uuidSchema }))
    .output(z.array(BreakResponseSchema));
/**
 * GET /api/breaks/shifts/:shiftId/breaks
 * List breaks by shift
 */
export const getBreaksByShift = oc
    .route({
    method: "GET",
    path: "/breaks/shifts/{shiftId}/breaks",
    summary: "List breaks by shift",
    tags: ["Breaks"],
})
    .input(z.object({ shiftId: uuidSchema }))
    .output(z.array(BreakResponseSchema));
/**
 * PATCH /api/breaks/:id
 * Update a break
 */
export const updateBreak = oc
    .route({
    method: "PATCH",
    path: "/breaks/{id}",
    summary: "Update a break",
    tags: ["Breaks"],
})
    .input(z.object({ id: uuidSchema }).merge(UpdateBreakInputSchema))
    .output(BreakResponseSchema);
/**
 * DELETE /api/breaks/:id
 * Delete a break
 */
export const deleteBreak = oc
    .route({
    method: "DELETE",
    path: "/breaks/{id}",
    summary: "Delete a break",
    tags: ["Breaks"],
    successStatus: 204,
})
    .input(z.object({ id: uuidSchema }))
    .output(z.void());
// ============================================
// Contract Router
// ============================================
export const breakContract = {
    create: createBreak,
    get: getBreak,
    getByJobRoleFamily: getBreaksByJobRoleFamily,
    getByShift: getBreaksByShift,
    update: updateBreak,
    delete: deleteBreak,
};
//# sourceMappingURL=break.js.map